/* eslint-disable no-unused-vars */

import React from 'react';
import { connect } from 'react-redux';
import ReactToPrint from 'react-to-print';
import moment from 'moment';

import S from 'constants/string.const';
import { withIsFromMobileApp } from 'hooks/useIsFromMobileApp.hook';
import { withGilt, withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ComponentToPrint from 'reports/Common/ComponentToPring';
import ProductSales from 'reports/RetailReport/ProductSales';
import ProductSalesByStylist from 'reports/RetailReport/ProductSalesByStylist';
import RetailPerformanceTable from 'reports/RetailReport/RetailPerformanceTable';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import { convertStylistsMapsToStylistTableData } from 'reports/utils';
const ReportsProps = ['salesReport', 'productSalesReport', 'productSalesByStylistReport'];

class RetailLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.componentRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    let revenueData;
    const currencyAbbr = this.props.currency;
    const { uniqueVisitsReport, t, formatDate } = this.props;

    if (this.checkIfAllDataIsLoaded()) {
      const stylistGroup = this.props.salesReport.lastRequestResponse.stylist_group;

      const nameServicesTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
      });
      const nameProductsTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
      });

      revenueData = convertStylistsMapsToStylistTableData(nameServicesTotalPriceMap, nameProductsTotalPriceMap, currencyAbbr, t);
    }
    return (
      <div className="has-protipbox">
        <div className="new-wraper">
          <div className="performance p1 box retail">
            {!this.checkIfAllDataIsLoaded() && (
              <div className="spinner-container">
                <div className="load-spinner" />
              </div>
            )}
            {this.checkIfAllDataIsLoaded() && revenueData && (
              <React.Fragment>
                <div className="banner default full-width">
                  <div style={{ width: '100%' }}>
                    <div className="cfix relative">
                      <span className="img-emoji-1" role="img" aria-labelledby="lamp">
                        {S.lamp}
                      </span>
                      <div className="text">
                        <strong>{t('businessReports.retail.proTip')}</strong>
                        {t('businessReports.retail.proTipDescription1')}
                      </div>
                    </div>
                    <div className="cfix relative">
                      <span className="img-emoji-2" role="img" aria-labelledby="lamp">
                        {S.lamp}
                      </span>
                      <div className="text">
                        <strong>{t('businessReports.retail.proTip')}</strong>
                        {t('businessReports.retail.proTipDescription2')}
                      </div>
                    </div>
                  </div>
                  {!this.props.isFromMobile && (
                    <div className="link">
                      <a
                        href="https://help.getslick.com/en/articles/2732392-how-to-add-retail-technical-products-using-the-slick-stock-scanner-app"
                        alt="Heed help"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('businessReports.retail.needHelp')}
                      </a>
                      <ReactToPrint trigger={() => <button className="btn-print-pdf-reports">{t('businessReports.retail.printPDFButton')}</button>} content={() => this.componentRef.current} />
                    </div>
                  )}
                </div>
                <div style={{ marginTop: '18px' }} />
                <ComponentToPrint ref={this.componentRef} componentRef>
                  <RetailPerformanceTable
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    revenueData={revenueData}
                    salesReport={this.props.salesReport.lastRequestResponse}
                    uniqueClientsReport={this.props.uniqueClientsReport.lastRequestResponse}
                    stylistList={this.props.stylistList}
                  />
                  <ProductSales
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    productSales={this.props.productSalesReport}
                  />
                  <ProductSalesByStylist
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    productSalesByStylist={this.props.productSalesByStylistReport}
                  />
                </ComponentToPrint>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
    clientCommunications: { clientList },
  } = state;
  const { salesReport, uniqueVisitsReport, rebookingReport, uniqueClientsReport, visitFrequencyReport, lastDatesSelected, appointmentsReport, productSalesReport, productSalesByStylistReport } =
    reports;
  const currency = selectCurrentSalonCurrency(state);
  return {
    salonId,
    clientList,
    lastDatesSelected,
    salesReport,
    uniqueVisitsReport,
    rebookingReport,
    uniqueClientsReport,
    visitFrequencyReport,
    appointmentsReport,
    stylistList,
    productSalesReport,
    productSalesByStylistReport,
    currency,
  };
}

export default connect(mapStateToProps)(withIsFromMobileApp(withGilt(withTranslation()(RetailLayout))));
